export const LOCAL_STORAGE_KEY = 'GROWTHBOOK_DEVICE_ID';
export const API_HOST = 'https://cdn.growthbook.io';
